import React from 'react';
import { Box } from '@apia/theme';
import { useUpdateEffect } from 'ahooks';
import useContext from '../../../../hooks/useContext';
import MakeField from '../fieldsStore/MakeField';
import FieldContext from '../fieldsStore/FieldContext';
import { IApiaSelect } from '../../../../types';
import IProperty from '../../../../JSApi/constants/IProperty';
import { getFieldErrorStyles } from '../style';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import DateInput from '../../../common/fields/DateInput';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';
import { useApiaFormContext } from '../page/ApiaForm';

const ApiaDatePickerRenderer = React.forwardRef<HTMLInputElement>((_, ref) => {
  const {
    state: { isValid, value },
    setValue,
    fireEvent,
  } = useContext(FieldContext);
  const { field, fieldId } = useContext(ApiaComponentContextPrimitive);
  const props = usePropsSelector(fieldId);
  const { attId, attLabel, attName, properties } = field as IApiaSelect;
  const { name } = properties;
  const { isReadonly, identifier } = useApiaFieldCommonProps();

  const [dateError, setDateError] = React.useState<string | null>(null);

  useUpdateEffect(() => {
    setDateError(null);
  }, [props.attributes?.index]);

  const { isFormReadOnly } = useApiaFormContext();

  if (!isFormReadOnly && !props[IProperty.PROPERTY_INPUT_AS_TEXT]) {
    return (
      <Box className="datePicker__field">
        <DateInput
          error={dateError}
          onError={setDateError}
          key={`${fieldId}_${attId}`}
          required={props[IProperty.PROPERTY_REQUIRED]}
          disabled={props[IProperty.PROPERTY_DISABLED]}
          readOnly={isReadonly}
          value={value as string}
          onChange={(ev) => {
            setValue(ev);
            fireEvent('onChange');
          }}
          onBlur={(ev) => {
            if (ev.target.value !== value) {
              setValue(ev.target.value);
              fireEvent('onChange');
            }
          }}
          autoComplete="off"
          name={name || attName}
          {...identifier}
          ref={ref}
          title={props[IProperty.PROPERTY_TOOLTIP] || attLabel}
          sx={{
            ...getFieldErrorStyles(isValid),
            input: { color: props[IProperty.PROPERTY_VALUE_COLOR] },
          }}
          buttonProps={{
            disabled: isReadonly || props[IProperty.PROPERTY_DISABLED],
          }}
          className="datePicker__input"
        />
      </Box>
    );
  }
  return (
    <Box
      as="span"
      {...identifier}
      sx={{
        color: props[IProperty.PROPERTY_VALUE_COLOR],
      }}
    >
      {value as string}
    </Box>
  );
});

const ApiaDatePicker = MakeField(ApiaDatePickerRenderer, {
  preSynchronize({
    fieldContext: {
      state: { lastValidValue, value },
    },
  }) {
    return lastValidValue === value ? 'cancel' : true;
  },
});

export default ApiaDatePicker;
